import React, { useState } from "react";
import Calendar from "react-calendar";
import { dateWrapper } from "core/lib/date.wrapper";

export type MonthPickerProps = {
    id: string,
    uniqueId?: string,
    onChange: any;
    initialValue?: Date,
    placeholder: string,
    disabled?: boolean,
    minDate?: Date,
    maxDate?: Date
}

const MonthPicker = (props: MonthPickerProps) => {
    const [value, onChange] = useState<any>(props.initialValue ?? new Date());
    const lastOpened = React.useRef(0);
    const uniqueId = props.uniqueId ?? props.id;

    const getOuterContainer = () => {
        return document.querySelector(`.${uniqueId}`) as HTMLDivElement;
    }

    const getReactDateContainer = () => {
        const outer = getOuterContainer();

        if (!outer) {
            return null;
        }

        return outer.querySelector(".rd-container") as HTMLDivElement;
    }

    const isOpen = () => {
        const container = getOuterContainer();

        if (!container) {
            return false;
        }

        return container.classList.contains(cssNames.focussed);
    }

    const closeCalendar = (ev: any) => {
        const timeOfClick = new Date().getTime();
        const diff = timeOfClick - lastOpened.current;

        // console.log(`lastOpened: ${uniqueId}`, lastOpened.current, "timeOfClick", timeOfClick, "diff", diff);

        if (lastOpened.current !== 0 && diff < 500) {
            return;
        }

        const container = getReactDateContainer();

        if (!container) {
            return;
        }

        const open = isOpen();

        if (!open) {
            return;
        }

        let target = ev.target as HTMLElement | null;

        while (target) {
            if (target.classList?.contains(cssNames.container)) {
                return;
            }

            target = target.parentElement;
        }

        console.log("Closing calendar");

        setDisplay(false);
    }

    const addOrRemoveCloseListener = (add = true) => {
        const el = document.getElementById("commercial-self-service");

        if (!el) {
            return;
        }

        if (!add) {
            el.removeEventListener("click", closeCalendar);
            return;
        }

        console.log(`Registering ${uniqueId}`);
        el.addEventListener("click", closeCalendar);
    }

    const cssNames = {
        outerContainer: "month-picker",
        hidden: "hidden",
        container: "rd-container",
        focussed: "focussed"
    };

    const toggleDisplay = () => {
        if (props.disabled ?? false) {
            return;
        }

        const show = !isOpen();

        console.log("toggle Display. setDisplay", show);
        setDisplay(show);
    }

    const setDisplay = (show: boolean) => {
        const outerContainer = getOuterContainer();

        if (!outerContainer) {
            return;
        }

        if (show) {
            lastOpened.current = new Date().getTime();
            outerContainer.classList.add(cssNames.focussed);
        } else {
            outerContainer.classList.remove(cssNames.focussed);
        }

        addOrRemoveCloseListener(show);
    }

    const setValue = (v: any) => {
        setDisplay(false);
        onChange(v);
        props.onChange(props.id, v);
    }

    const thisMonth = () => {
        const date = new Date();
        date.setDate(1);
        return date;
    }

    const html = value ? dateWrapper(value).fullMonthAndYear : props.placeholder;

    const className = `${cssNames.outerContainer} ${uniqueId} ` + (isOpen() ? cssNames.focussed : "");

    const iconClassName = "icon icon-calendar_32x32" + (props.disabled ?? false ? " disabled" : "");

    return (
        <div id={props.id} className={className}>
            <div className="year-month">
                <span dangerouslySetInnerHTML={{ __html: html }}></span>
                <i className={iconClassName} onClick={e => toggleDisplay()}></i>
            </div>

            <input type="hidden" value={value ? value.toString() : ""} placeholder="hidden-value" />
            {value && <label>{props.placeholder}</label>}

            <div className={cssNames.container}>
                <Calendar
                    view="year"
                    maxDetail="year"
                    value={value}
                    formatMonth={(l, d) => dateWrapper(d).shortMonth}
                    minDate={props.minDate}
                    maxDate={props.maxDate}
                    onClickMonth={e => setValue(e)}
                />
                <section className="rd-footer">
                    <button onClick={() => setValue(undefined)}>Clear</button>
                    <button onClick={() => setValue(thisMonth())}>This Month</button>
                </section>
            </div>
        </div>
    );
}

export default MonthPicker;
